import React, { useEffect } from "react";

export default function MultiStepDropdown({
  segmentId,
  courses,
        topics,
        achievements,
  filteredMainData,
  selectedCourse,
  selectedSubCourseTopic,
  selectedAchievement,
  onChangeCourse,
  onChangeSubCourseTopic,
  onChangeAchievement,
  isSegmentChanged,
  isCourseChanged, 
        isSubTopicChanged, 
        isAchievementChanged,
        onLabelsChange,
        allSegmentData,
        handleSegmentChange,
        achivementDropdownOnAlarm,
        achievementsLoading
}) {
  const hasAnyChange = isSegmentChanged || isCourseChanged || isSubTopicChanged || isAchievementChanged;

  useEffect(() => {
    if (selectedSubCourseTopic && selectedSubCourseTopic !== 0 && !achievementsLoading && achievements.length === 0) {
      onChangeAchievement(-1);
    }
  }, [selectedSubCourseTopic, achievements, achievementsLoading]);


  useEffect(() => {
    // 0 Find Segment Name

    const segment =  Array.isArray(allSegmentData) && segmentId
    ? allSegmentData.find((c) => c.Id === segmentId)
    : null;

    const segmentName = segment ? `${segment.ClassTypeName}${segment.ExamTypeId > 0 ? ` - ${segment.ExamTypeName}` : ""}`:null


    // 1️⃣ Find course name
    const course =
      Array.isArray(courses) && selectedCourse
        ? courses.find((c) => c.Id === selectedCourse)
        : null;
    const courseName = course ? course.Name : null;
  
    // 2️⃣ Flatten all subtopics across topic groups
    let allSubTopics = [];
    if (topics && typeof topics === "object") {
      const topicArrays = Object.keys(topics).map(function (key) {
        return topics[key];
      });
      allSubTopics = [].concat.apply([], topicArrays);
    }
  
    const selectedSub =
      allSubTopics.length > 0
        ? allSubTopics.find((sub) => sub.Id === selectedSubCourseTopic)
        : null;
  
    const topicName = selectedSub ? selectedSub.Title : null;
    const subTopicName = selectedSub ? selectedSub.Name : null;
  
    // 3️⃣ Find achievement name
    let achievementName = null;
    if (
      selectedAchievement &&
      Array.isArray(achievements) &&
      achievements.length > 0
    ) {
      const found = achievements.find(function (a) {
        return a.AchievementId === selectedAchievement;
      });
      achievementName = found ? found.Name : selectedAchievement==-1?"Kazanım Bulunamadı": selectedAchievement==-2? "Çoklu Kazanım": null;
    }
  
    // 4️⃣ Emit to parent if function exists
    if (typeof onLabelsChange === "function") {
      onLabelsChange({
        segmentName: segmentName,
        courseName: courseName,
        topicName: topicName,
        subTopicName: subTopicName,
        achievementName: achievementName,
      });
    }
  }, [
    selectedCourse,
    selectedSubCourseTopic,
    selectedAchievement,
    courses,
    topics,
    achievements,
  ]);
  
  // if (!filteredMainData || !filteredMainData.Courses) {
  //   return <div style={{ textAlign: "center" }}>Veri bulunamadı</div>;
  // }

  // 1️⃣ Get the selected course and its topics
  // const course =
  //   filteredMainData.Courses &&
  //   filteredMainData.Courses.find(function (c) {
  //     return c.CourseId === selectedCourse;
  //   });

  // const courseTopics =
  //   course && Array.isArray(course.CourseTopics)
  //     ? course.CourseTopics
  //     : [];

  // // 2️⃣ Flatten all subtopics under their parent topic
  // const allSubCourseTopics = courseTopics.reduce(function (acc, topic) {
  //   const subs = Array.isArray(topic.SubCourseTopics)
  //     ? topic.SubCourseTopics
  //     : [];
  //   const mapped = subs.map(function (sub) {
  //     return {
  //       CourseTopicId: topic.CourseTopicId,
  //       CourseTopicName: topic.CourseTopicName,
  //       SubCourseTopicId: sub.SubCourseTopicId,
  //       SubCourseTopicName: sub.SubCourseTopicName,
  //       Achievements: sub.Achievements || [],
  //     };
  //   });
  //   return acc.concat(mapped);
  // }, []);

  // // 3️⃣ Get selected subtopic’s achievements
  // var selectedSub = null;
  // for (var i = 0; i < allSubCourseTopics.length; i++) {
  //   if (allSubCourseTopics[i].SubCourseTopicId === selectedSubCourseTopic) {
  //     selectedSub = allSubCourseTopics[i];
  //     break;
  //   }
  // }

  // const achievements =
  //   selectedSub && Array.isArray(selectedSub.Achievements)
  //     ? selectedSub.Achievements
  //     : [];

  // 4️⃣ Render dropdowns

 
  return (
    <div style={styles.container}>
{/* Step 0: ExamType */}
<div style={styles.dropdownWrapper}>
        <label style={styles.label}>Sınıf veya Sınav Seç:</label>
        <select 
        value={segmentId || ""} 
        onChange={e => handleSegmentChange(+e.target.value)}
        style={{
          ...styles.select,
          ...(isSegmentChanged ? styles.changed : {}),
        }}
        >
  <option value="">Seçiniz</option>
  {allSegmentData.map(c => (
    <option key={c.Id} value={c.Id}>{`${c.ClassTypeName}${c.ExamTypeId > 0 ? ` - ${c.ExamTypeName}` : ""}`}</option>
  ))}
</select>
      </div>
      {/* Step 1: Course */}
      <div style={styles.dropdownWrapper}>
        <label style={styles.label}>Ders Seç:</label>
        <select 
        value={selectedCourse || ""} 
        onChange={e => onChangeCourse(+e.target.value)}
        style={{
          ...styles.select,
          ...(isCourseChanged ? styles.changed : {}),
        }}
        >
  <option value="">Seçiniz</option>
  {courses.map(c => (
    <option key={c.Id} value={c.Id}>{c.Name}</option>
  ))}
</select>
      </div>

      {/* Step 2: Topic → Subtopic */}
      {selectedCourse !== 0 && selectedCourse && (
        <div style={styles.dropdownWrapper}>
          <label style={styles.label}>Konu ve Alt Konu Seç:</label>
          <select 
          value={selectedSubCourseTopic || ""} 
          onChange={e => onChangeSubCourseTopic(+e.target.value)}
          style={{
            ...styles.select,
            ...(isSubTopicChanged ? styles.changed : {}),
          }}
          >
    <option value={0}>Seçiniz</option>
    {Object.entries(topics).map(([title, subs]) => (
      <optgroup key={title} label={title}>
        {subs.map(sub => (
          <option key={sub.Id} value={sub.Id}>{sub.Name}</option>
        ))}
      </optgroup>
    ))}
  </select>
        </div>
      )}

      {/* Step 3: Achievements */}
      {selectedSubCourseTopic !== 0 && selectedSubCourseTopic &&  (
        <div style={styles.dropdownWrapper}>
          <label style={styles.label}>Kazanım Seç:</label>
          <select 
          value={!achievementsLoading && achievements.length === 0 ? -1 : (selectedAchievement || "")}
          onChange={e => onChangeAchievement(+e.target.value)}
          style={{
            ...styles.select,
            ...(isAchievementChanged ? styles.changed : {}),
            ...(achivementDropdownOnAlarm ? styles.alarmDropdown:{})
          }}
          >
    {!achievementsLoading  && achievements.length === 0? (
      <option value={-1}>Kazanımı bu listede bulamıyorum.</option>
    ) : (
      <>
        <option value={0}>Seçiniz</option>
        {achievements.map(a => (
          <option key={a.AchievementId} value={a.AchievementId}>{a.Name}</option>
        ))}
        <option value={-1}>Kazanımı bu listede bulamıyorum.</option>
        <option value={-2}>Bu listedeki birden fazla kazanımı kapsıyor.</option>
      </>
    )}
  </select>
        </div>
      )}

      {/* Summary */}
      {/* {selectedCourse && (
        <div style={styles.summary}>
          <strong>Seçilen: </strong>
          {course ? course.CourseName : ""}
          {selectedSub
            ? " → " +
              selectedSub.CourseTopicName +
              " → " +
              selectedSub.SubCourseTopicName
            : ""}
          {selectedAchievement
            ? (function () {
                var found = null;
                for (var j = 0; j < achievements.length; j++) {
                  if (achievements[j].AchievementId === selectedAchievement) {
                    found = achievements[j];
                    break;
                  }
                }
                return found ? " → " + found.AchievementName : "";
              })()
            : ""}
        </div>
      )} */}
      {/* {hasAnyChange && (
  <div style={styles.summary}>
    <strong>Yeni Seçilen:</strong>{" "}
    {course ? course.CourseName : ""}
    {selectedSub
      ? " → " +
        selectedSub.CourseTopicName +
        " → " +
        selectedSub.SubCourseTopicName
      : ""}
    {selectedAchievement
      ? (function () {
          var found = achievements.find(
            (a) => a.AchievementId === selectedAchievement
          );
          return found ? " → " + found.AchievementName : "";
        })()
      : ""}
  </div>
)} */}

    </div>
  );
}

// 💅 Styles
var styles = {
  container: {
    width: "100%",
    maxWidth: 480,
    margin: "40px auto 20px auto",
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    fontFamily: "sans-serif",
  },
  dropdownWrapper: {
    display: "flex",
    flexDirection: "column",
  },
  label: {
    marginBottom: 6,
    fontWeight: "bold",
  },
  select: {
    padding: "8px 12px",
    borderRadius: 6,
    border: "1px solid #ccc",
    fontSize: 15,
  },
  summary: {
    marginTop: 20,
    background: "#f5f5f5",
    padding: 10,
    borderRadius: 6,
  },
  select: {
    padding: "8px 36px 8px 12px", // 👈 extra right padding
    borderRadius: 6,
    border: "1px solid #ccc",
    fontSize: 15,
    width: "100%",
    boxSizing: "border-box",
    appearance: "none",           // remove default browser styles
    backgroundColor: "#fff",
    backgroundImage:
      "url('data:image/svg+xml;utf8,<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 140 140\"><polyline points=\"20,50 70,100 120,50\" stroke=\"black\" stroke-width=\"10\" fill=\"none\" stroke-linecap=\"round\"/></svg>')", // 👈 custom arrow
    backgroundRepeat: "no-repeat",
    backgroundPosition: "right 15px center", // 👈 arrow position
    backgroundSize: "16px",
  },
  changed: {
    borderColor: "#22c55e", // Tailwind green-500
    boxShadow: "0 0 0 3px rgba(34, 197, 94, 0.3)", // soft green glow
    transition: "all 0.2s ease-in-out",
    // fontSize: "20px",
    // fontWeight: "800",
  },
  alarmDropdown:{
    borderColor: "red", // Tailwind green-500
    boxShadow: "red", // soft green glow
    transition: "all 0.2s ease-in-out",
    // fontSize: "20px",
    // fontWeight: "800",
  }
  
};
